import PaymentInfoBaseService from './PaymentInfoBaseService'

export default class TransferInfoService extends PaymentInfoBaseService {
  call(): string {
    return `A payment was transferred ${
      this.payment.amountCents > 0 ? 'to' : 'from'
    } this booking`
  }
}
